import React from "react";
import Keysensor from "../components/Keysensor";
import { withRouter } from "react-router-dom";
import backImage from "../images/type.jpeg";

const Title = withRouter(props => {
  const handleKeyDown = e => {
    e.preventDefault();
    if (e.keyCode === 32) {
      // alert(e.keyCode);
      props.history.push("/start");
    }
  };

  const handlekeyUp = e => {};

  const style = {
    width: "100%",
    height: "calc(100vh - 50px - 50px)",
    margin: "0 auto",
    backgroundImage: `url(${backImage}`,
    backgroundColor: "rgba(255,255,255,0.7)",
    backgroundBlendMode: "lighten",
    backgroundPosition: "bottom",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center"
  };

  const pressStyle = {
    padding: "20px 50px",
    color: "#666666",
    fontSize: "3rem",
    textAlign: "center",
    verticalAlign: "middle",
    border: "solid 5px rgba(255,165,0,0.7)",
    margin: "0px auto 30px",
    backgroundColor: "rgba(255,255,255,0.7)",
    borderRadius: "80px"
  };

  return (
    <Keysensor onKeyDown={handleKeyDown} onKeyUp={handlekeyUp}>
      <div style={style}>
        <p style={pressStyle}>Press Space key</p>
      </div>
    </Keysensor>
  );
});

export default Title;
